<main class="p-6 bg-lGray950 rounded-3xl">
  <div class="mb-5 flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
    <div>
      <h1 class="text-[2.05rem] font-bold leading-8 text-color">Trilhas</h1>
      <p class="mt-1 text-sm subtext-color">Gerencie e construa novas trilhas de aprendizado</p>
    </div>

    <div class="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-end xl:w-auto">
      <div class="relative w-full sm:w-[388px]">
        <l-icon class="pointer-events-none absolute left-5 top-1/2 -translate-y-1/2 text-[1.35rem] text-lGray600" icon="search" />
      <input
        lInput
        class="w-full !h-10 !rounded-full !bg-lGray900 !border-lGray700 !text-lSecondary placeholder:!text-lSecondary !pl-14 !pr-5 !text-base"
        placeholder="Pesquisar trilha"
        [formControl]="searchControl"
      />
      </div>

      <button
        lButton
        [bType]="buttonTypeEnum.PRIMARY"
        [bSize]="buttonSizeEnum.MEDIUM"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        class="!h-10 !min-w-[180px] !px-8 !text-base"
        (click)="openCreateTrackModal()"
      >
        Criar trilha
      </button>
    </div>

    
  </div>

  <l-track-table
    [limit]="limit"
    [page]="page"
    [data]="tracks"
    [sort]="sort"
    [total]="total"
    [isLoading]="isLoading"
    [getRowActions]="getRowActions.bind(this)"
    (pageChange)="onChangePage($event)"
    (sortChange)="onChangeSort($event)"
  />
</main>
